import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { QueryClientProvider } from '@tanstack/react-query';
import { translate } from '~l10n/client';
import activity from 'activity';
import user from 'user';

import { TeacherApplicationContextProvider } from '~shared/context/TeacherApplicationContext';
import { TeacherApplicationContext } from '~shared/context/TeacherApplicationContext';
import { RouterProvider } from '~teacher/context/RouterContext';
import { queryClient } from '~teacher/queryClient';
import header from 'HeaderController';
import launchQuizModal from 'LaunchQuizController';
import saPopup from 'ShortAnswerController';

import popup from '../../../../shared/components/popup/PopupController';
import { ErrorView } from '../../../shared/error/ErrorView';
import LaunchView from '../views/LaunchView';

let router = null;

class LaunchController {
  doLaunch(teacherRouter, inviteCode) {
    router = teacherRouter;
    header.render('launch');
    controller.renderView(inviteCode, router);
  }

  renderView(inviteCode, router) {
    ReactDOM.render(
      <ErrorView>
        <RouterProvider router={router}>
          <TeacherApplicationContextProvider
            applicationContext={TeacherApplicationContext.Socrative}
          >
            <QueryClientProvider client={queryClient}>
              <LaunchView controller={controller} inviteCode={inviteCode} />
            </QueryClientProvider>
          </TeacherApplicationContextProvider>
        </RouterProvider>
      </ErrorView>,
      document.getElementById('main-content')
    );
  }

  profilePopupClosed() {
    popup.closePopup();
    router.routeToProfileInfo();
  }

  quizClicked() {
    activity.checkBeforeStartingActivity(() => {
      launchQuizModal.open({
        activityType: activity.QUIZ,
        router: router,
      });
    });
  }

  spaceRaceClicked() {
    activity.checkBeforeStartingActivity(() => {
      launchQuizModal.open({
        activityType: activity.SPACE_RACE,
        router: router,
      });
    });
  }

  exitTicketClicked() {
    activity.startExitTicket({
      success: controller.activityStarted,
    });
  }

  mcClicked() {
    controller.startQuestion('mc');
  }

  tfClicked() {
    controller.startQuestion('tf');
  }

  saClicked() {
    activity.checkBeforeStartingActivity(controller.startSaConfirmed);
  }

  startSaConfirmed() {
    saPopup.render({
      startCallback: controller.activityStarted,
    });
  }

  startQuestion(type) {
    activity.startQuickQuestion({
      type: type,
      require_names: false,
      callback: controller.activityStarted,
    });
  }

  activityStarted() {
    router.navigate('results/live', { trigger: true });
  }
}

let controller = new LaunchController();
module.exports = controller;
